<template>
  <el-dialog
    title="历史版本"
    :visible.sync="visible"
    width="1000px"
    @close="handleClose">
    <el-form ref="form" :model="form" inline class="table-search-bar" >
      <el-form-item label="版本编码" prop="code">
        <el-input v-model="form.code" placeholder="请输入编码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="listData"
      style="width: 100%"
      tooltip-effect="light">
      <el-table-column
        label="排序"
        width="50px">
        <template slot-scope="scope">
          {{(listState.pageNo - 1) * 10 + scope.$index + 1}}
        </template>
      </el-table-column>
      <el-table-column
        prop="code"
        label="版本编码"
        show-overflow-tooltip>
      </el-table-column>
      <template v-for="(col, index) in columns">
        <el-table-column
          :key="index"
          :prop="col.prop"
          :label="col.label"
          :show-overflow-tooltip="col.showOverflowTooltip">
          <template v-slot="scope">
            <template v-if="col.render">
              <!-- 渲染函数组件 -->
              <render-cell
                :render="col.render"
                :row="scope.row"
                :index="scope.$index"
              />
            </template>
            <span v-else>{{ scope.row[col.prop] }}</span>
          </template>
        </el-table-column>
      </template>
      <el-table-column
        label="操作"
        width="120px">
        <template slot-scope="scope">
          <el-button @click="handleLook(scope.row)" v-permission="'0300101'">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20 ,50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      :current-page="listState.pageNo"
      background>
    </el-pagination>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
const RenderCell = {
  functional: true,
  props: ['render', 'row', 'index'],
  render: (h, ctx) => {
    return ctx.props.render(h, ctx.props.row, ctx.props.index)
  }
}
export default {
  name: 'historyVersionDialog',
  components: { RenderCell },
  props: ['show', 'info', 'source'],
  data () {
    return {
      visible: false,
      listState: {
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      listData: [],
      form: {
        code: ''
      }
    }
  },
  computed: {
    ...mapGetters({ logisticsColumns: 'getLogisticsColumns', pricingRulesColumns: 'getPricingRulesColumns' }),
    columns () {
      if (this.source === 'logistics') {
        return this.logisticsColumns
      } else {
        return this.pricingRulesColumns
      }
    }
  },
  methods: {
    ...mapActions(['getPricingRulesList', 'getLogisticsSolutionList']),
    handleSizeChange (val) {
      this.listState.pageSize = val
      this.handleSearch()
    },
    handleCurrentChange (val) {
      this.listState.pageNo = val
      this.handleSearch()
    },
    handleSearch () {
      const params = {
        ...this.form,
        ...this.listState
      }
      if (this.source === 'logistics') {
        this.getLogisticsSolutionList(params).then(res => {
          this.listData = res.list || []
          this.total = res.total
          this.listState.pageNo = res.pageNum
          this.listState.pageSize = res.pageSize
        })
      } else {
        this.getPricingRulesList(params).then(res => {
          this.listData = res.list || []
          this.total = res.total
          this.listState.pageNo = res.pageNum
          this.listState.pageSize = res.pageSize
        })
      }
    },
    handleClose () {
      this.$refs.form.resetFields()
      this.$emit('update:show', false)
    },
    // 查询表单，表格重置
    handleReset () {
      this.$refs.form.resetFields()
      this.handleSearch()
    },
    // 查看
    handleLook (row) {
      if (this.source === 'logistics') {
        this.$router.push({ name: 'logisticsDetail', query: { id: row.id } })
      } else {
        this.$router.push({ name: 'pricingRulesDetail', query: { id: row.id } })
      }
    }
  },
  watch: {
    show (newVal) {
      this.visible = newVal
      if (newVal) {
        this.handleSearch()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
